// import { createSlice } from "@reduxjs/toolkit";

// const applicantDetailsSlice = createSlice({
//   name: "applicantDocuments",
//   initialState: {
//     //    entityPanAddressDetails: [],
//     adhaarFrontDocument: [],
//     aadhaarDocumentAddress: [],
//     voterBackDocument: [],
//     voterIDDocumentAddress: [],
//     panAddressDetails: [],
//     bankDocumentAddress: [],
//     coBorrowerAadhaarFrontDocument:[],
//     coBorrowerAadhaarBackDocument:[],
//     coBorrowerVoterFrontDocument:[],
//     coBorrowerVoterBackDocument:[],
//     coBorrowerPanDocument:[],
//   },
//   reducers: {
//     setAadhaarDocumentAddress: (state, action) => {
//       state.aadhaarDocumentAddress = action.payload;
//     },
//     setPanDetails: (state, action) => {
//       state.panAddressDetails = action.payload;
//     },
//     setVoterIdDocumentAddress: (state, action) => {
//       state.voterIDDocumentAddress = action.payload;
//     },
//     // setEntityPanDetails: (state, action) => {
//     //   state.entityPanAddressDetails = action.payload;
//     // },
//     setBankDetails: (state, action) => {
//       state.bankDocumentAddress = action.payload;
//     },
//     setAdhaarFrontDocument: (state, action) => {
//       state.adhaarFrontDocument = action.payload;
//     },
//     setVoterBackDocument: (state, action) => {
//       state.voterBackDocument = action.payload;
//     },
//     resetDocumentData: (state, action) => {
//       state.aadhaarDocumentAddress = [];
//       state.panAddressDetails = [];
//       state.voterIDDocumentAddress = [];
//       state.adhaarFrontDocument = []
//       // state.entityPanAddressDetails = [];
//     },
//   },
// });

// export const {
//   setPanDetails,
//   setAadhaarDocumentAddress,
//   setVoterIdDocumentAddress,
//   resetDocumentData,
//   setAdhaarFrontDocument,
//   setBankDetails,
//   setVoterBackDocument
// } = applicantDetailsSlice.actions;

// export default applicantDetailsSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";

const applicantDetailsSlice = createSlice({
  name: "applicantDocuments",
  initialState: {
    adhaarFrontDocument: [],
    aadhaarDocumentAddress: [],
    voterBackDocument: [],
    voterIDDocumentAddress: [],
    panAddressDetails: [],
    bankDocumentAddress: [],
    coBorrowerAadhaarFrontDocument: [],
    coBorrowerAadhaarBackDocument: [],
    coBorrowerVoterFrontDocument: [],
    coBorrowerVoterBackDocument: [],
    coBorrowerPanDocument: [],
  },
  reducers: {
    setAadhaarDocumentAddress: (state, action) => {
      state.aadhaarDocumentAddress = { data: { data: action.payload } };
    },
    setPanDetails: (state, action) => {
      state.panAddressDetails = { data: { data: action.payload } };
    },
    setVoterIdDocumentAddress: (state, action) => {
      state.voterIDDocumentAddress = { data: { data: action.payload } };
    },
    setBankDetails: (state, action) => {
      state.bankDocumentAddress = { data: { data: action.payload } };
    },
    setAdhaarFrontDocument: (state, action) => {
      state.adhaarFrontDocument = { data: { data: action.payload } };
    },
    setVoterBackDocument: (state, action) => {
      state.voterBackDocument = { data: { data: action.payload } };
    },
    setCoBorrowerAadhaarFrontDocument: (state, action) => {
      state.coBorrowerAadhaarFrontDocument = { data: { data: action.payload } };
    },
    setCoBorrowerAadhaarBackDocument: (state, action) => {
      state.coBorrowerAadhaarBackDocument = { data: { data: action.payload } };
    },
    setCoBorrowerVoterFrontDocument: (state, action) => {
      state.coBorrowerVoterFrontDocument = { data: { data: action.payload } };
    },
    setCoBorrowerVoterBackDocument: (state, action) => {
      state.coBorrowerVoterBackDocument = { data: { data: action.payload } };
    },
    setCoBorrowerPanDocument: (state, action) => {
      state.coBorrowerPanDocument = { data: { data: action.payload } };
    },
    
    resetDocumentData: (state, action) => {
      state.aadhaarDocumentAddress = [];
      state.panAddressDetails = [];
      state.voterIDDocumentAddress = [];
      state.adhaarFrontDocument = [];
      state.voterBackDocument = [];
      state.bankDocumentAddress = [];
      state.coBorrowerAadhaarFrontDocument = [];
      state.coBorrowerAadhaarBackDocument = [];
      state.coBorrowerVoterFrontDocument = [];
      state.coBorrowerVoterBackDocument = [];
      state.coBorrowerPanDocument = [];
    },
  },
});

export const {
  setPanDetails,
  setAadhaarDocumentAddress,
  setVoterIdDocumentAddress,
  resetDocumentData,
  setAdhaarFrontDocument,
  setBankDetails,
  setVoterBackDocument,
  setCoBorrowerAadhaarFrontDocument,
  setCoBorrowerAadhaarBackDocument,
  setCoBorrowerVoterFrontDocument,
  setCoBorrowerVoterBackDocument,
  setCoBorrowerPanDocument,
} = applicantDetailsSlice.actions;

export default applicantDetailsSlice.reducer;
